{
    "warning": "¡ADVERTENCIA!",
    "message": "No escribas o pegues código que no entiendas.\nUsar esta consola podría permitir que personas malintencionadas roben tu identidad y tu información usando un ataque llamado Self-XSS."
}
